import { projectId, publicAnonKey } from '/utils/supabase/info';

const API_BASE = `https://${projectId}.supabase.co/functions/v1/make-server-ba6cedc4`;

export type WalletLedgerEntry = {
  id: string;
  userId: string;
  type: 'credit' | 'debit';
  amount: number;
  reason: 'gift_send' | 'gift_receive' | 'admin_adjustment';
  counterpartyUserId?: string;
  battleRoomId?: string;
  createdAt: string;
};

function authHeaders(accessToken?: string | null): Record<string, string> {
  const headers: Record<string, string> = {
    Authorization: `Bearer ${publicAnonKey}`,
    'Content-Type': 'application/json',
  };
  if (accessToken) headers['X-User-Token'] = accessToken;
  return headers;
}

async function parseJson<T>(res: Response): Promise<T> {
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error((json as any)?.error || 'Wallet request failed');
  }
  return json as T;
}

export async function getWalletBalance(accessToken?: string | null): Promise<{ userId: string; balance: number }> {
  const res = await fetch(`${API_BASE}/wallet/balance`, {
    headers: authHeaders(accessToken),
  });
  return parseJson<{ userId: string; balance: number }>(res);
}

export async function getWalletLedger(accessToken?: string | null, limit = 25): Promise<{ userId: string; ledger: Array<WalletLedgerEntry> }> {
  const res = await fetch(`${API_BASE}/wallet/ledger?limit=${limit}`, {
    headers: authHeaders(accessToken),
  });
  return parseJson<{ userId: string; ledger: Array<WalletLedgerEntry> }>(res);
}

export async function sendWalletGift(params: {
  receiverUserId: string;
  idempotencyKey: string;
  amount: number;
  battleRoomId?: string;
  accessToken?: string | null;
}): Promise<{
  senderBalance: number;
  receiverBalance: number;
  giftId: string;
  replayed: boolean;
}> {
  const { accessToken, ...body } = params;
  const res = await fetch(`${API_BASE}/wallet/gift`, {
    method: 'POST',
    headers: authHeaders(accessToken),
    body: JSON.stringify(body),
  });
  return parseJson<{
    senderBalance: number;
    receiverBalance: number;
    giftId: string;
    replayed: boolean;
  }>(res);
}
